import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopoverModule } from 'primeng/popover';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-popover',
  standalone: true,
  imports: [CommonModule, PopoverModule],
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopoverComponent {
  aberto = input(false);
  aoAbrir = output<Event>();
  aoFechar = output<Event>();
  style = input<Record<string, string>>();

  @ViewChild('popover') popover?: Popover;

  get overlayVisible(): boolean {
    return this.popover?.overlayVisible || false;
  }

  abrir(evento: Event): void {
    this.popover?.toggle(evento);
  }

  fechar(): void {
    this.popover?.hide();
  }

  aoAbrirPainel(evento: Event): void {
    this.aoAbrir.emit(evento);
  }

  aoFecharPainel(evento: Event): void {
    this.aoFechar.emit(evento);
  }
}
